<template>
  <!--<div class="row" v-if="ftfaCheck()">
    <div class="col-xs-12">
      <div
        class="input-errors"
        style="text-align: center"
        v-html="d.submitFtfaWarning"
      ></div>
    </div>
  </div>-->
  <div class="row submit-container">
    <div class="col-xs-12">
      <div class="button-wrapper">
        <div class="button-container-item">
          <button
            data-submit=""
            class="button secondary"
            @click="submit('')"
            :disabled="visual.disableSubmit"
          >
            {{ getButtonText() }}
          </button>
        </div>

        <div v-if="d.showRecruiters" class="button-container-item">
          <button 
            class="button secondary"
            @click="submit('pay')"
            >
              Brug FarPay
            </button>
        </div>

      </div>
    </div>
  </div>
</template>
<script>
export default {
  data: (instance) => {
    return {
      values: instance.store[instance.store.currentCulture].values.personalDetails,
      d: instance.store[instance.store.currentCulture].dictionary,
      product: instance.store[instance.store.currentCulture].values.productDetails,
      visual: instance.store[instance.store.currentCulture].values.visualDetails,
      culture: instance.store.currentCulture,
    };
  },
  mounted() {
    this.emitter.on("culture-change", () => {
      this.d = this.store[this.store.currentCulture].dictionary;
    });
  },
  methods: {
    ftfaCheck() {
      return !(
        this.values.dimStudentSu != "trorSu" && this.values.dimStudentPension != "ja"
      );
    },
    getButtonText() {
      if (this.d.showRecruiters) {
        return "Skip FarPay";
      }

      if (this.values.payByCompany) {
        return this.d.submitbuttonwithoutpayment;
      } 
      //else if (this.product.subscriptiontype == "student") {
      //  return this.d.submitbuttonwithoutpayment;
      //} 
      else {
        return this.d.submitbuttonwithpayment;
      }
    },
    submit(recruitmentState) {
      if (!this.ftfaCheck()) this.visual.showLoadingSpinner = true;
     
      //this.product.recruitmentState = recruitmentState; ?? why does this not work for 'en'
      this.store[this.store.currentCulture].values.productDetails.recruitmentState = recruitmentState;
      this.store[this.store.currentCulture].values.memberNo =  this.merges.userDetails.membershipNo;

      this.$emit("submit");
    },
  },
};
</script>
<style scoped lang="postcss">
.button-wrapper {
  display: flex;

  .button-container-item {
    margin: 0 auto;
  }
}

.input-errors {
  color: red;
  margin-top: -15px;
  + .input-errors {
    margin-top: 0;
  }
}

.submit-container {
  padding-top: 20px; /* ADDS 20px to the prior section padding */
  padding-bottom: 80px; /* ADDS 80px to the section padding */
}
</style>
